const ProductionCapacityView = ({ productionCategory }) => {
  if (productionCategory.type === "BY_QTY") {
    if (productionCategory.timeList.length === 0)
      return (
        <div className="text-pink-600">
          No time set for this production category.
        </div>
      );

    return (
      <div className="flex items-center space-x-2">
        {productionCategory.timeList.map((i, index) => (
          <div key={index} className="whitespace-nowrap">
            {i.qty}: {i.days} days
          </div>
        ))}
      </div>
    );
  }
  return <div>{productionCategory.qtyPerDay} / day</div>;
};

export default ProductionCapacityView;
